<template>
    <div>
        <o-notification type="is-dark" has-icon>Drag and drop items between lists</o-notification>
        <div class="columns">
            <div class="column">
                <o-tabs v-model="activeTab" class="project-services">
                    <o-tab-item :value="0" label="Main Services">
                        <div class="columns">
                            <div class="column is-6">
                                <div class="panel-block">
                                    <p class="control">
                                        <input class="input is-small" type="text" placeholder="search" v-model="availableFilter">
                                    </p>
                                </div>
                                <draggable
                                    :model-value="services"
                                    item-key="id"
                                    group="people"
                                    @change="$event => restoreSelected($event)"
                                    style="min-height: 100%"
                                >
                                  <template #item="{ element, index }">
                                    <a
                                        :class="['panel-block', 'is-active', [isAvailableServiceHidden(element, availableFilter) ? 'is-hidden' : '']]"
                                    >{{ element.title }}</a>
                                  </template>
                                </draggable>
                            </div>
                            <div class="column is-6">
                                <div class="panel-block">
                                    <p class="control">
                                        <input class="input is-small" type="text" placeholder="search" v-model="selectedFilter">
                                    </p>
                                </div>
                                <draggable
                                        :model-value="selectedServices"
                                        item-key="id"
                                        group="people"
                                        @change="$event => addSelected($event, services)"
                                        style="min-height: 100%"
                                        ref="selected"

                                >
                                  <template #item="{ element }">
                                      <a
                                          :class="['panel-block', 'is-active', [isSelectedServiceHidden(element, availableFilter) ? 'is-hidden' : '']]"
                                          v-show="element.type === 'initial'"
                                          :key="element.id"
                                      >{{ element.title }}
                                        <br>
                                      </a>
                                  </template>
                                </draggable>
                            </div>
                        </div>
                    </o-tab-item>
                    <o-tab-item :value="1" label="Sub-services">
                        <div v-for="service in selectedServices">
                            <div v-show="service.service_id && service.type === 'initial'">
                                <label class="label">{{ service.title }} Sub-Services <span style="color: red">*</span> </label>
                                <o-checkbox
                                    v-model="service.work_types"
                                    v-for="wt in workTypesByIds(serviceById(service.service_id).work_types)"
                                    :custom-value="wt.id"
                                    :key="wt.id"
                                    :native-value="wt.id"
                                >
                                    {{ wt.title }}
                                </o-checkbox>
                            </div>
                        </div>
                    </o-tab-item>
                </o-tabs >
            </div>
        </div>
    </div>
</template>

<script>
import ProjectServices from '../mixins/ProjectServices'
import {mapActions, mapGetters} from 'vuex'

export default {
        mixins: [ProjectServices],

        props: ['secondaryTabIndex'],

        data () {
            return {
                type: 'initial',
                activeTab: 0
            }
        },

      mounted() {
      },

      computed: {
            ...mapGetters(['initialServices', 'projectServicesBySource']),

            services: {
                get () {
                    return this.initialServices
                },
                set () {}
            },


        },

        methods: {
          ...mapActions(['removeEditingProjectService', 'removeProjectService2']),

          removeService(projectService) {
            // if (typeof projectService.id === 'string' && projectService.id.includes('s')) {
            //   this.removeEditingProjectService(projectService)
            // } else {
            //   this.removeProjectService2(projectService)
            // }
            this.$store.state.projectServices.items = this.$store.state.projectServices.items.filter(item => item.id !== projectService.id);

          },
        },

        watch: {
            'secondaryTabIndex'(value) {
                this.activeTab = value
            },

            'activeTab'(value) {
                this.$emit('secondary-tab-changed', value)
            },

            'selectedServices'(value) {
                const workTypes = _.find(this.selectedServices, (service) => {
                    this.$emit('update:model-value', this.workTypesByIds(this.serviceById(service.service_id).work_types).length > 0)
                    return this.serviceById(service.service_id).work_types.length
                })

                this.$emit('input', workTypes)
            },
        }
    }
</script>
